<div paddingX='10' paddingT='15' appPadding appMargin paddingB="20" class="mainDiv">
  <router-outlet></router-outlet>
</div>